import util from './../../../util'
import models from './models'

export default {
    SET_ID(state, payload) {
        state.id = payload
    },
    SET_CODE(state, payload) {
        state.code = payload
    },
    SET_TYPE(state, payload) {
        state.type = payload
    },
    SET_PAGE(state, payload) {
        state.page = payload
    },
    SET_ERROR(state, payload) {
        state.error = payload
    },
    SET_SESSION(state, payload) {
        state.session = payload
    },
    SET_SIDEBAR(state, payload) {
        state.sidebar = payload
    },
    SET_SECURITY(state, payload) {
        state.security = payload
    },
    SET_SIGNUP(state, payload) {
        state.signup = payload
    },
    SET_INIT_AUTH(state, payload) {
        state.init_auth = payload
    },
    SET_PREVIEW(state, payload) {
        state.preview = payload
    },
    SET_OTP(state, payload) {
        state.otp = payload
    },
    SET_PRINTING(state, payload) {
        state.printing = payload
    },
    SET_CREATED(state, payload) {
        state.created = payload
    },
    SET_COMPLETE(state) {
        state.complete = true
    },
    SET_DOWNLOAD(state, payload) {
        state.download = payload
    },
    SET_THEME(state, payload) {
        util.set(state.theme, models.theme(payload))
    },
    SET_TEMPLATE(state, payload) {
        util.set(state.template, models.template(payload))
    },
    SET_INFO(state, payload) {
        util.set(state.info, models.info(payload))
    },
    SET_MACROS(state, payload) {
        state.macros = payload
    },
    SET_REQUEST(state, payload) {
        state.request = payload
    },
    SET_LOADING(state, payload) {
        state.loading = payload
    },
    SET_PDFS(state, payload) {
        state.pdfs = payload
    },

    SET_MEMBERS(state, payload) {
        state.members = payload.map(m => models.member(m))
    },
    SET_ORIGINAL_MEMBER(state, payload) {
        state.member_original = payload
    },
    UNSET_MEMBERS(state, payload) {
        state.members = []
    },
    ADD_MEMBER(state, payload) {
        util.add(state.members, models.member(payload), 'type', true)
    },
    REMOVE_MEMBER(state, payload) {
        state.members = util.remove(state.members, payload.type, 'type')
    },

    SET_PANELS(state, payload) {
        state.panels = payload.map(p => models.panel(p))
    },
    UNSET_PANELS(state, payload) {
        state.panels = []
    },
    ADD_PANEL(state, payload) {
        util.add(state.panels, models.panel(payload), 'id', true)
    },
    REMOVE_PANEL(state, payload) {
        state.panels = util.remove(state.panels, payload.id)
    },

    SET_GROUPS(state, payload) {
        state.groups = payload.map(g => models.group(g))
    },
    UNSET_GROUPS(state, payload) {
        state.groups = []
    },
    ADD_GROUP(state, payload) {
        util.add(state.groups, models.group(payload), 'id', true)
    },
    REMOVE_GROUP(state, payload) {
        state.groups = util.remove(state.groups, payload.id)
    },

    SET_ELEMENTS(state, payload) {
        state.elements = payload.map(e => models.element(e))
    },
    UNSET_ELEMENTS(state, payload) {
        state.elements = []
    },
    ADD_ELEMENT(state, payload) {
        util.add(state.elements, models.element(payload), 'id', true)
    },
    REMOVE_ELEMENT(state, payload) {
        state.elements = util.remove(state.elements, payload.id)
    },

    SET_SIGNATURES(state, payload) {
        state.signatures = payload.map(e => models.signature(e))
    },
    UNSET_SIGNATURES(state, payload) {
        state.signatures = []
    },
    ADD_SIGNATURE(state, payload) {
        util.add(state.signatures, models.signature(payload), 'id', true)
    },
    REMOVE_SIGNATURE(state, payload) {
        state.signatures = util.remove(state.signatures, payload.id)
    },

    SET_SIGNATURE_PENDING(state, payload) {
        state.signature_pending = payload
    },

    QUEUE(state, payload) {
        util.add(
            state.queue,
            {
                id: payload.id,
                group: payload.hasOwnProperty('group') && payload.group ? payload.group : '',
                value: payload.value,
                remove: payload.remove && payload.remove == true,
                upload: payload.upload && payload.upload == true,
                _key: payload.id + '|' + new Date().getTime(),
                _default: payload.hasOwnProperty('default') && payload.default === true
            },
            'id',
            true
        )
    },
    UNQUEUE(state, payload) {
        if (payload.hasOwnProperty('_key')) {
            state.queue = util.remove(state.queue, payload._key, '_key')
        } else {
            state.queue = util.remove(state.queue, payload.id)
        }
    },
    SET_CALCULATED(state, payload) {
        payload.forEach(e => {
            if (e.value) {
                let c = state.template.elements.find(d => d.connection == e.definition)
                let element = state.elements.find(el => {
                    return (
                        el.panel == e.panel && el.group == e.group && el.definition == (c ? c.definition : e.definition)
                    )
                })
                if (element) {
                    if (!element.exists) {
                        Object.assign(element, { ...e, ...{ exists: true } })
                    } else {
                        element.value = JSON.parse(JSON.stringify(e.value))
                    }
                } else {
                    util.add(state.elements, e, 'id', true)
                }
            }
        })
    },
    SET_DYNAMIC(state, payload) {
        state.dynamic = payload
    },
    ADD_DYNAMIC(state, element) {
        if (state.dynamic.hasOwnProperty(element.definition)) {
            util.add(state.dynamic[element.definition], element, 'id', true)
        }
        let c = state.template.elements.find(e => e.id == element.definition)
        if (c && c.connection && state.dynamic.hasOwnProperty(c.connection)) {
            util.add(
                state.dynamic[c.connection],
                {
                    id: element.id,
                    group: element.group,
                    panel: element.panel,
                    value: element.value,
                    definition: c.connection
                },
                'id',
                true
            )
        }
    },
    REMOVE_POPUP(state, payload) {
        state.template.panels.find(p => p.id == payload).description = ''
    },
    REFRESH_DATA(state, payload) {
        let tpl = state.template
        let panels = state.panels.filter(p => p.type != 'COCLIENT').map(p => p.id)
        let group = state.groups[0].id
        state.members.find(m => m.type == 'CLIENT').name = payload.members.find(m => m.type == 'CLIENT').name
        state.panels.find(p => p.type == 'ACCOUNT').id = payload.panels.find(p => p.type == 'ACCOUNT').id
        state.panels.find(p => p.type == 'CLIENT').id = payload.panels.find(p => p.type == 'CLIENT').id
        state.groups[0].id = payload.groups[0].id
        state.elements.forEach(e => {
            let type =
                tpl.panels.find(
                    p =>
                        p.id == tpl.groups.find(g => g.id == tpl.elements.find(el => el.id == e.definition).group).panel
                ).type == 'ACCOUNT'
                    ? 'ACCOUNT'
                    : 'CLIENT'
            if (panels.indexOf(e.panel) !== -1) {
                e.panel = state.panels.find(p => p.type == type).id
            }
            if (group == e.group) {
                e.group = state.groups[0].id
            }
            if (payload.elements && payload.elements.length > 0) {
                let element = payload.elements.find(
                    el => el.panel == e.panel && el.group == e.group && el.definition == e.definition
                )
                if (element) {
                    e.id = element.id
                    e.value = element.value
                }
            }
        })
    },
    SET_TEMPLATE_ELEMENT(state, payload) {
        util.add(state.template.elements, payload, 'id', true)
    },
    SET_ANALYTICS_ENTER(state, id) {
        let panel = state.analytics.panels.find(p => p.id == id)
        if (!panel) {
            panel = { id: id, value: 0, current: 0 }
        }
        panel.current = new Date().getTime()
        util.add(state.analytics.panels, panel, 'id', true)
    },
    SET_ANALYTICS_LEAVE(state, id) {
        let panel = state.analytics.panels.find(p => p.id == id)
        if (panel) {
            let time = panel.current
            panel.current = new Date().getTime()
            let value = parseInt(panel.current - time)
            panel.value = panel.value + value
            state.analytics.total = state.analytics.total + value
            util.add(state.analytics.panels, panel, 'id', true)
        }
    },
    RESET_ANALYTICS(state) {
        state.analytics = { total: 0, panels: [] }
    },
    SET_TIMEOUT(state) {
        if (state.timeout.timer != null) {
            clearTimeout(state.timeout.timer)
        }
        state.timeout.timer = window.setTimeout(function () {
            console.log('Signout due to inactivity.')
            window.location.reload()
        }, state.timeout.ttl)
    },
    ADD_ACTIVE_GROUP(state, { panelId, definitionId, groupId }) {
        const exists = state.active_groups.some(
            item => item.panelId === panelId && item.definitionId === definitionId && item.groupId === groupId
        )
        if (!exists) {
            state.active_groups.push({ panelId, definitionId, groupId })
        }
    },
    REMOVE_ACTIVE_GROUP(state, { panelId, definitionId, groupId }) {
        state.active_groups = state.active_groups.filter(
            item => !(item.panelId === panelId && item.definitionId === definitionId && item.groupId === groupId)
        )
    },
    RESET_ACTIVE_GROUPS(state) {
        state.active_groups = []
    }
}
